import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const VehicleCategoryListComponent = loadable(
  () => import("../../components/VehicleCategory/VehicleCategoryList")
);

const VehicleCategoryList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Vehicle Category
        </span>
      </div>
      <VehicleCategoryListComponent />
    </>
  );
};

export default VehicleCategoryList;
